import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProgramModalInAppNotificationViewModel } from '../../models/wholesaler-api-models';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InAppNotificationsService {
  constructor(private http: HttpClient) {}

  /**
   * Get modal notification for display on page visit
   * Returns null if no notification should be displayed
   */
  async getModalNotification(): Promise<ProgramModalInAppNotificationViewModel | null> {
    try {
      return await firstValueFrom(this.http.get<ProgramModalInAppNotificationViewModel>('InAppNotification/modal-notification'));
    } catch (error) {
      console.error('Failed to load modal notification', error);
      return null;
    }
  }
}
